<template>
  <v-card>
    <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
      Запись на прием
    </v-card-title>
    <v-card-text>
      <p>
        <span v-if="$store.state.customer"
          >Пациент: {{ $store.state.customer.profile.last_name }} {{ $store.state.customer.profile.first_name }}
          {{ $store.state.customer.profile.middle_name }}</span
        >
        <span v-else>Пациент не найден</span>
      </p>

      <p>Доктор: {{ appointment.doctor.full_name }} {{ doctorSpecs }}</p>

      <p>Дата: {{ appointment.start_at }}</p>
      <template v-if="!isFinished">
        <p>
          <v-btn color="primary" @click="open(appointment)">Открыть видеоконференцию</v-btn>
        </p>
        <div class="d-flex">
          <v-text-field
            :value="appointment.link"
            readonly
            append-icon="mdi-content-copy"
            variant="filled"
            label="Ссылка на консультацию"
            type="text"
            @click:append="copy(appointment.link)"
            persistent-hint
            :hint="copyMessage"
          ></v-text-field>
        </div>
      </template>
      <p v-else>Консультация завершена</p>
    </v-card-text>

    <v-card-actions>
      <v-btn v-if="!isFinished" type="button" color="red" @click="cancelAppointment()">Отменить приём</v-btn>
      <v-btn v-else color="red" @click="openDocument()">Открыть заключение</v-btn>
      <v-spacer></v-spacer>
      <v-btn type="button" @click="close()">Закрыть</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { formModal } from "@/mixins/modal/form-modal.js";
import { ScheduleRepository } from "@/modules/schedule/schedule.repository.js";
import { mapMutations } from "vuex";
import { CustomerService } from "@/services/api/customer.service";
import AddDocument from "@/modules/documents/add-document/AddDocument.vue";

export default {
  name: "ScheduleAppointmentDetail",
  components: { AddDocument },
  props: {
    appointment: {
      type: Object,
      required: true,
    },
    calendarEvent: {
      type: Object,
      required: true,
    },
  },
  mixins: [formModal],
  data() {
    return {
      copyMessage: "",
    };
  },
  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
    isFinished() {
      return this.calendarEvent.status === "finished";
    },
    doctorSpecs() {
      if (this.appointment.doctor.specializations && this.appointment.doctor.specializations.length) {
        return ", " + this.appointment.doctor.specializations.join(", ");
      }
      return "";
    },
  },
  methods: {
    ...mapMutations("appointment", ["SET_CURRENT_APPOINTMENT"]),
    open(item) {
      this.SET_CURRENT_APPOINTMENT({ videoLink: item.link, docId: item.doc_id, id: item.id });
      this.close();
    },
    async copy(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.copyMessage = "Ссылка скопирована";
      } catch (e) {
        console.log(`e =>`, e);
        this.copyMessage = `Скопировать ссылку не удалось`;
      }
    },
    async cancelAppointment() {
      const result = await this.$dialog.confirm({
        // title: "Вы действительно хотите отменить запись?",
        text: "Вы действительно хотите отменить запись?",
      });
      if (!result) {
        return;
      }

      const { success, message } = await ScheduleRepository.cancelAppointment(this.appointment.id);

      if (success) {
        this.$dialog.notify.success(`Консультация отменена`);
        this.$emit("submit", true);
        this.close();
        return;
      }

      this.$dialog.notify.error(message);
    },
    async openDocument() {
      try {
        const r = await CustomerService.getDocument(this.customerId, this.appointment.doc_id);

        await this.$dialog.showAndWait(AddDocument, {
          customerForm: r,
          width: 600,
          doctorId: this.doctorId,
          persistent: true,
          readonly: true,
        });
        this.loading = true;
        await this.$store.dispatch("ikp/loadEvents");
        this.loading = false;
      } catch (e) {
        console.log(`e =>`, e);
        if (e?.response.status === 404) {
          this.$dialog.notify.error(`Документ №${this.appointment.doc_id} не найден`);
        } else {
          this.$dialog.notify.error("Не удалось загрузить документ");
        }
      }
    },
  },
};
</script>

<style scoped></style>
